import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#145291ff",
    },
  },
  typography: {
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 15,
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          backgroundColor: "#f9f9fc",
        },
        columnHeaders: {
          textTransform: "capitalize",
          backgroundColor: "#eaeaea",
          color: "#333",
        },
        row: {
          "&.Mui-selected": {
            backgroundColor: "#ffecec !important",
          },
          "&:hover": {
            backgroundColor: "#f5f5f5",
          },
        },
        cell: {
  textTransform: "capitalize",
  "&.email-cell": {
    textTransform: "none",
  },
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
}

      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "var(--color-primary)",
          color: "#fff !important",
          "&:hover": {
            backgroundColor: "var(--color-secondary)",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          "&.Mui-checked": {
            color: "#43a047",
          },
          "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#43a047",
          },
        },
      },
    },
  },
});

export default theme;

